var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.alert)?_c('div',{staticClass:"alert",class:[_vm.level]},[(_vm.title)?_c('h3',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_c('div',[_c('span',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }